import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import AddBoxIcon from "@mui/icons-material/AddBox";

import { Section } from "../../../../../../shared/components/Section";
import { setAdditionalBundle } from "../../../../../../store/mobile/actions";
import { getProductDataForConfig } from "../../../../../../store/mobile/selectors/productConfig";
import { AdditionalBundles } from "../../../../components/Mobile/AdditionalBundles";

export const AdditionalBundle = ({ targetConfigs }: any) => {
  const dispatch = useDispatch();
  const [bundleId, setBundleId] = useState("0");

  const bundles = useSelector((state) =>
    _.get(
      getProductDataForConfig(state, targetConfigs[0]),
      "mobile.dynamic_properties.additional_bundle"
    )
  );

  const bundleIds = useSelector((state) =>
    _.map(targetConfigs, (targetConfig: any) =>
      _.get(
        getProductDataForConfig(state, targetConfig),
        "mobile.dynamic_properties.additional_bundle.available_options"
      )
    )
  );

  if (!bundles) return null;

  const updatedBundles = {
    ...bundles,
    available_options: _.intersection(...bundleIds),
  };

  if (updatedBundles.available_options.length === 0) return null;

  return (
    <Section title={"Additional Bundles"} avatar={<AddBoxIcon />}>
      <AdditionalBundles
        propertyName="additional_bundle"
        bundles={updatedBundles}
        selectedBundleId={bundleId}
        onChangeBundle={(event) => {
          setBundleId(event.target.value);

          targetConfigs.forEach((targetConfig: any) =>
            dispatch(setAdditionalBundle(event.target.value, targetConfig))
          );
        }}
      />
    </Section>
  );
};
